import { Quaternion, Vector3 } from 'three';

/** A camera pose: position plus orientation. */
export interface CameraTransform {
  position: Vector3;
  quaternion: Quaternion;
}

export function createCameraTransform(): CameraTransform {
  return { position: new Vector3(), quaternion: new Quaternion() };
}
